import { isSameId, getSortedCards } from "../../helpers";
export default function (store, { id, card, replace }) {
    const state = store.getState();
    let originalCard;
    let cards = state.cards.map(c => {
        if (isSameId(c.id, id)) {
            originalCard = { ...c };
            if (replace) {
                return { id, ...card };
            }
            return { ...c, ...card };
        }
        return c;
    });
    if (state.sort) {
        cards = getSortedCards({ ...state, cards }, store.sortRule);
    }
    store.setState({ cards });
    return () => {
        store.in.exec("update-card", {
            id,
            card: originalCard,
            replace: true,
            $meta: { skipHistory: true },
        });
    };
}
//# sourceMappingURL=update.js.map